
export interface PreprocessingRulesState {
  preprocessingRules: PreprocessingRuleItem[],
  preprocessingRuleItem?: PreprocessingRuleItem
}

export interface PreprocessingRuleItem {
  id?: number,
  partner?: string,
  partner_id?: number,
  account?: string,
  account_id?: number,
  channel?: string,
  channel_id?: number,
  originator?: string,
  originator_id?: number,
  template?: string,
  template_id?: number,
  rule: string,
  position: string | null,
}

export class PreprocessingRuleItemImpl implements PreprocessingRuleItem {
  // partner?: string;
  partner_id?: number;
  // account?: string;
  account_id?: number;
  // channel?: string;
  channel_id?: number;
  // originator?: string;
  originator_id?: number;
  // template?: string;
  template_id?: number;
  rule: string;
  position: string | null;

  constructor() {
    this.rule = '';
    this.position = null;
    this.partner_id = undefined;
    this.account_id = undefined;
    this.channel_id = undefined;
    this.originator_id = undefined;
    this.template_id = undefined;
  }
}

export interface PreprocessingRuleFilter {
  rule?: string,
  position?: string,
  partner?: string,
  account?: string,
  channel?: string,
  originator?: string,
  template?: string,
}

export class PreprocessingRuleFilterImpl implements PreprocessingRuleFilter {

}
